var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.41 2.98022C13.9847 2.45096 14.9638 2.2137 15.7663 2.78871C16.7912 3.52303 17.414 4.60577 17.3432 5.99464C17.2997 6.84712 16.9973 7.76098 16.4546 8.73596H19.0456C20.8621 8.73596 22.2618 10.3375 22.0186 12.1376L21.0035 19.6516C20.8024 21.1398 19.5321 22.25 18.0305 22.25L4.33398 22.25C3.22941 22.25 2.33398 21.3546 2.33398 20.25V10.25C2.33398 9.14542 3.22942 8.24999 4.33398 8.24999H7.68819L13.41 2.98022ZM8.33398 10.3742L14.7131 4.49906C15.168 4.86382 15.3759 5.30207 15.3458 5.89271C15.309 6.61303 14.9088 7.6728 13.798 9.12964C13.5675 9.43198 13.5284 9.83889 13.697 10.1796C13.8657 10.5204 14.213 10.736 14.5932 10.736H19.0456C19.6511 10.736 20.1177 11.2698 20.0366 11.8698L19.0215 19.3839C18.9544 19.8799 18.531 20.25 18.0305 20.25H8.33398V10.3742ZM6.33398 20.25V10.25L4.33398 10.25V20.25L6.33398 20.25ZM14.7675 4.44946L14.7663 4.45024L14.7675 4.44946Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpX2);
export default __webpack_public_path__ + "static/media/ThumbsUpX2.2f3d33ee497edcce0c13745074139b7a.svg";
export { ForwardRef as ReactComponent };